import { FLOW_COLOR } from 'constants/App';

export default {
  palette: {
    background: {
      default: '#FFF',
    },
    primary: {
      main: FLOW_COLOR,
      contrastText: '#FFF',
    },
    secondary: {
      main: '#F4F4F5',
      contrastText: '#5F5F5F',
    },
    error: {
      main: 'rgba(188, 56, 56, 1)',
    },
    text: {
      primary: '#262626',
      secondary: 'rgba(61, 61, 61, 0.85)', // OP grey = #616161
    },
    tertiary: {
      main: 'rgba(250, 250, 250, 1)',
      contrastText: '#5F5F5F',
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        body: {
          color: '#262626',
          fontFamily: 'Roboto',
          letterSpacing: -0.5,
        },
        '.company-logo': {
          maxWidth: 'min(400px, 80%)',
        },
        ':is(.company-logo__login, .company-logo__validate-account)': {
          maxHeight: '120px',
        },
        ':is(.company-logo__checkout, .company-logo__booking-summary, .company-logo__purchase)': {
          maxHeight: '70px',
        },
        '.company-logo__carpark-information': {
          maxHeight: '80px',
        },
        '.checkoutCardTitle': {
          color: FLOW_COLOR,
          fontSize: 20,
          fontWeight: 500,
        },
        '.checkoutCardSubtitle': {
          color: '#525252',
          fontSize: 16,
          fontWeight: 500,
          paddingRight: 40,
          paddingLeft: 40,
        },
        '.checkoutCardBody': {
          color: '#525252',
          fontSize: 14,
          fontStyle: 'italic',
          fontWeight: 400,
        },
        '.bookingOverstayTitle': {
          color: FLOW_COLOR,
          fontSize: 20,
          fontWeight: 500,
        },
        '.bookingOverstaySubtitle': {
          color: '#525252',
          fontSize: 16,
          fontWeight: 500,
          paddingRight: 40,
          paddingLeft: 40,
        },
        '.bookingOverstayBody': {
          color: '#525252',
          fontSize: 14,
          fontStyle: 'italic',
          fontWeight: 400,
        },
        '.checkoutTitle': {
          color: '#525252',
          fontSize: 20,
          fontWeight: 400,
        },
        '.checkoutTitleInversed': {
          color: FLOW_COLOR,
          fontSize: 20,
          fontWeight: 400,
        },
        '.checkoutTutorialBox': {
          color: '#FFF',
          fontSize: 16,
          borderRadius: 4,
          padding: 15,
        },
        '.tutorialTitle': {
          fontSize: 18,
          fontWeight: 500,
        },
        '.tutorialCircleBox': {
          borderRadius: '50%',
          width: 32,
          height: 32,
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 18,
          fontWeight: '600',
        },
        '.tutorialBackgroundColorOne': {
          backgroundColor: FLOW_COLOR,
        },
        '.tutorialBackgroundColorTwo': {
          backgroundColor: 'rgba(12, 179, 228, 1)',
        },
        '.tutorialBackgroundColorThree': {
          backgroundColor: 'rgba(122, 56, 191, 1)',
        },
        '.tutorialColorOne': {
          color: FLOW_COLOR,
        },
        '.tutorialColorTwo': {
          color: 'rgba(12, 179, 228, 1)',
        },
        '.tutorialColorThree': {
          color: 'rgba(122, 56, 191, 1)',
        },
        '.infoItemLink': {
          fontSize: 14,
          fontWeight: '400',
        },
        '.infoItemContact': {
          color: FLOW_COLOR,
          fontSize: 18,
        },
        '.infoItemContactInversed': {
          fontSize: 16,
        },
        '.bookCard': {
          borderRadius: '4px',
          border: '1px solid #FAFAFA',
          background: '#FFF',
          boxShadow: '0px 0px 3px 1px rgba(167, 171, 171, 0.43)',
          padding: '25px 15px',
          color: '#04249C',
        },
        '.bookCardTitle': {
          color: FLOW_COLOR,
          fontSize: 18,
          fontWeight: 500,
        },
        '.bookCardBody': {
          fontSize: 15,
          fontWeight: 500,
          letterSpacing: '-0.805px',
        },
        '.bookPageTitle': {
          color: FLOW_COLOR,
          fontSize: 28,
          fontWeight: 500,
          textTransform: 'uppercase',
          marginBottom: '4vh',
          textWrap: 'balance',
        },
        '.myOnDemandAccessInformation': {
          fontSize: 16,
          textWrap: 'balance',
        },
        '.contactLink': {
          color: 'inherit',
        },
        '.carparkFeaturesList': {
          listStyleType: 'none',
          textAlign: 'center',
          fontSize: 16,
          color: FLOW_COLOR,
          borderWidth: 1,
          borderStyle: 'solid',
          borderColor: FLOW_COLOR,
        },
        '.responsiveBanner': {
          gap: '10px',
          fontSize: '16px',
          lineHeight: 'normal',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          textWrap: 'balance',
        },
        '.loginCardTitle': {
          color: FLOW_COLOR,
          fontSize: 20,
          fontWeight: 500,
        },
        '.msgSignupSuccessInfo': {
          backgroundColor: 'rgba(250, 250, 250, 1)',
          color: FLOW_COLOR,
          fontSize: 16,
          padding: 21,
        },
        '.myBookingInfoCardContent': {
          color: FLOW_COLOR,
          marginTop: 30,
          fontSize: 16,
          fontWeight: 500,
        },
        '.myBookingInfoPriceContent': {
          color: FLOW_COLOR,
        },
        '.myBookingInfoPriceText': {
          fontSize: 16,
        },
        '.onDemandSummaryInfoPriceText': {
          fontSize: 14,
        },
        '.onDemandSummaryText': {
          fontSize: 16,
          color: 'rgba(82, 82, 82, 1)',
          fontWeight: 500,
          letterSpacing: -0.5,
        },
        '.accessWayInfoLabel': {
          fontSize: 14,
          color: 'rgba(64, 64, 64, 1)',
        },
        '.accessWayNestedItemText': {
          fontSize: 16,
        },
        '.priceBox': {
          color: FLOW_COLOR,
          border: `1px solid ${FLOW_COLOR}`,
          borderRadius: '4px',
          fontSize: 16,
          padding: 15,
          width: '100%',
        },
        '.priceRow': {
          '& > :first-child': {
            fontStyle: 'italic',
            fontWeight: 400,
          },
          '& > :nth-child(2)': {
            fontWeight: 700,
          },
        },
        '.error404FirstNumber': {
          color: FLOW_COLOR,
          fontSize: 80,
          fontWeight: 600,
        },
        '.error404SecondNumber': {
          color: '#0CB3E4',
          fontSize: 80,
          fontWeight: 600,
        },
        '.error404ThirdNumber': {
          color: '#7A38BF',
          fontSize: 80,
          fontWeight: 600,
        },
        '.error404Title': {
          color: FLOW_COLOR,
          fontSize: 24,
          fontWeight: 600,
        },
        '.error404TextBold': {
          color: '#525252',
          fontSize: 21,
          fontWeight: 500,
        },
        '.error404Text': {
          color: '#525252',
          fontSize: 16,
          fontStyle: 'italic',
          fontWeight: 400,
        },
        '.moreContent': {
          color: FLOW_COLOR,
          fontSize: 16,
          fontWeight: 400,
          textAlign: 'center',
        },
        '.moreTitle': {
          color: FLOW_COLOR,
          fontSize: 16,
          fontWeight: 500,
        },
        '.moreTermsOfServiceContent': {
          color: FLOW_COLOR,
          fontSize: 12,
          fontWeight: 300,
        },
        '.info-box': {
          borderRadius: 4,
          padding: 20,
          maxWidth: 700,
          margin: '40px auto',
          position: 'relative',
        },
        '.border-color-1': {
          border: '3px solid rgba(4, 36, 156, 1)',
        },
        '.border-color-2': {
          border: '3px solid rgba(0, 51, 153, 0.8)',
        },
        '.border-color-3': {
          border: '3px solid rgba(60, 85, 177, 0.66)',
        },
        '.badge-number': {
          position: 'absolute',
          top: '-20px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 40,
          height: 40,
          color: 'white',
          borderRadius: '50%',
          textAlign: 'center',
          lineHeight: 2 /* Center the number vertically */,
          fontSize: 20,
        },
        '.badge-number-color-1': {
          backgroundColor: 'rgba(4, 36, 156, 1)',
        },
        '.badge-number-color-2': {
          backgroundColor: 'rgba(0, 51, 153)',
        },
        '.badge-number-color-3': {
          backgroundColor: 'rgba(60, 85, 177)',
        },
        '.card-text': {
          color: 'rgba(4, 36, 156, 1)',
        },
        '.flag-container': {
          borderRadius: 5,
          overflow: 'hidden',
          cursor: 'pointer',
          width: 35,
        },
        '.flag-container img': {
          scale: 1.2,
          width: '100%',
        },
      },
    },
    MuiTab: {
      root: {
        backgroundColor: FLOW_COLOR,
        '&:hover': {
          opacity: 0.9,
        },
      },
      textColorInherit: {
        color: '#FFF',
      },
    },
    MuiTabScrollButton: {
      root: {
        backgroundColor: FLOW_COLOR,
        color: '#FFF',
        '&$disabled': {
          opacity: 0.8,
          color: FLOW_COLOR,
        },
      },
    },
    MuiTableRow: {
      root: {
        '&$selected': {
          backgroundColor: 'rgba(225, 245, 251, 0.85)',
        },
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.750rem',
        fontWeight: 400,
        backgroundColor: 'rgb(97, 97, 97)',
      },
    },
    MuiCard: {
      root: {
        borderRadius: '4px',
        border: '1px solid #FAFAFA',
        background: '#FFF',
        boxShadow: '0px 0px 3px 1px rgba(167, 171, 171, 0.43)',
        padding: '30px',
      },
    },
    MuiCardContent: {
      root: {
        padding: 0,
        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
    MuiAlert: {
      root: {
        borderRadius: 4,
        letterSpacing: -0.5,
      },
      standardError: {
        color: 'rgba(188, 56, 56, 1)',
        backgroundColor: 'rgba(188, 56, 56, 0.17)',
      },
      standardSuccess: {
        color: 'rgba(47, 149, 45, 1)',
        backgroundColor: 'rgba(237, 247, 238, 1)',
      },
    },
    MuiTypography: {
      colorSecondary: {
        color: FLOW_COLOR,
      },
    },
    MuiLink: {
      root: {
        color: FLOW_COLOR,
        fontFamily: 'Roboto',
        letterSpacing: -0.5,
      },
    },
  },
};



// WEBPACK FOOTER //
// ./containers/themes/cpmClient.js